import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {connect} from 'react-redux';
import {Modal} from 'antd';
import ListMenu from "..";
import AccountActions from 'bukku/redux/Account/actions';

const {
    archive: archiveAccount,
    delete: deleteAccount,
} = AccountActions;

class AccountListMenu extends Component {
    toggleActivation = record => {
        const _this = this;
        const isArchived = record.is_archived;

        Modal.confirm({
            title: (isArchived ? t`Activate Account` : t`Deactivate Account`),
            content: isArchived ?
                t`Do you really want to activate ${record.name}?` :
                t`Do you really want to deactivate account ${record.name}?`,
            onOk() {
                _this.props.archiveAccount(record.id, {
                    is_archived: !isArchived,
                });
            },
            onCancel() {},
            okText: (isArchived ? t`Activate` : t`Deactivate`),
            cancelText: t`Cancel`,
        });
    };

    onDelete = record => {
        const {
            deleteAccount,
        } = this.props;

        Modal.confirm({
            title: t`Delete Account`,
            content: t`Do you really want to PERMANENTLY delete the account ${record.name}?`,
            onOk() {
                deleteAccount(record.id);
            },
            onCancel() {},
            okText: t`Delete`,
            cancelText: t`Cancel`,
        });
    };

    getItems = () => {
        const { record } = this.props;
        const items = [];

        items.push({
            key: 'view',
            label: t`View`,
            url: `/accounting/accounts/${record.id}`,
        });

        if (record.is_archived) {
            items.push({
                key: 'activate',
                label: t`Activate`,
                action: () => this.toggleActivation(record),
                isUpdate: true,
            });
        }
        else {
            items.push({
                key: 'deactivate',
                label: t`Deactivate`,
                disabled: record.is_locked,
                action: () => this.toggleActivation(record),
                isUpdate: true,
            });
        }

        items.push({
            key: 'delete',
            label: t`Delete`,
            disabled: record.is_locked,
            action: () => this.onDelete(record),
            isDelete: true,
        });

        return items;
    };

    render() {
        return (
            <ListMenu items={this.getItems()} />
        );
    }
}
export default connect(() => ({
}), {
    archiveAccount,
    deleteAccount,
})(AccountListMenu);
